import { SwimlaneItem } from '@rikstv/play-common/src/forces/assetDetails/assetDetails.types';
import logger from '@rikstv/play-common/src/utils/logger/logger';

import { Swimlane } from '../../pages/types';

type SwimlaneItemType =
  | 'menuItems'
  | 'swimmingPoolItems'
  | 'swimmingPoolPortraitItems'
  | 'featuredItems'
  | 'heroItems'
  | 'superWideHeroItems'
  | 'portraitItems'
  | 'numberedItems'
  | 'liveChannels'
  | 'continueWatchingItems'
  | 'myListItems'
  | 'standardItems';

type SwimlaneType = Extract<Swimlane['type'], 'ContinueWatching' | 'MyList'>;

type SwimlaneStyle = Exclude<Swimlane['style'], 'ContinueWatching' | 'MyList'>;

const typeMap: Record<SwimlaneType, SwimlaneItemType | undefined> = {
  ContinueWatching: 'continueWatchingItems',
  MyList: 'myListItems',
};

const styleMap: Record<SwimlaneStyle, SwimlaneItemType | undefined> = {
  Live: 'liveChannels',
  Standard: 'standardItems',
  MenuText: 'menuItems',
  MenuThumbnail: 'menuItems',
  MenuCircle: 'menuItems',
  MenuLogo: 'menuItems',
  SwimmingPool: 'swimmingPoolItems',
  SwimmingPoolPortrait: 'swimmingPoolPortraitItems',
  Featured: 'featuredItems',
  Hero: 'heroItems',
  SuperWideHero: 'superWideHeroItems',
  StandardPortrait: 'portraitItems',
  HeroPortrait: 'portraitItems',
  NumberedPortrait: 'numberedItems',
  StandardNumbered: 'numberedItems',
};

export function getSwimlaneItemTypes(
  swimlaneItems: SwimlaneItem[],
  swimlaneStyle: Swimlane['style'],
  swimlaneType: Swimlane['type']
): SwimlaneItemType | undefined {
  if (!swimlaneItems || swimlaneItems.length === 0) {
    return undefined;
  }

  if (swimlaneType === 'OnTvNow' && swimlaneStyle === 'Live') {
    return 'liveChannels';
  }

  if (swimlaneType in typeMap) {
    return typeMap[swimlaneType as SwimlaneType];
  }

  if (swimlaneStyle in styleMap) {
    return styleMap[swimlaneStyle as SwimlaneStyle];
  }

  logger.error(`Unhandled swimlane combination: type="${swimlaneType}", style="${swimlaneStyle}"`);
  return undefined;
}
